/*
* @Author: zoujie.wzj
* @Date:   2015-10-30 16:19:35
* @Last Modified by:   zoujie.wzj
* @Last Modified time: 2015-10-30 17:15:25
*/

    //1_GLP:代表detail页面get latest price打点来源;1_ATM:代表detail页面主表单打点来源;1_ZTC:代表直通车页面打点来源
    //2_ATM_DETAIL:代表minisite-product页面主表单打点来源
    //1_SO_GLP:代表商家在线detail页面get latest price打点来源;1_SO_ATM:代表商家在线 detail页面打点来源;
    //2_P_SO_ATM:代表商家在线minisite-product页面打点来源
    //2_WB_DETAIL：代表旺遍天下独立detail页面打点来源
    var fromProductRegExp = /^(?:1_GLP|1_ATM|1_ZTC|1_SO_GLP|1_SO_ATM|2_P_SO_ATM|2_WB_DETAIL|2_ATM_DETAIL|1_GLOBAL_ATM)$/;

    //2_GLP:代表minisite页面get latest price打点来源;2_ATM:代表minisite非product页面主表单打点来源;2_ZD:代表minisite页面右侧固定框
    //2_SO_GLP:代表商家在线非minisite-product页面get lastest price打点来源;2_SO_ATM:代表商家在线非minisite-product页面打点来源;
    //2_P_SO_GLP:代表商家在线minisite-product页面get latest price打点来源;
    //2_WB_COMPANY：代表旺遍天下company页面打点来源
    var fromMinisiteRegExp = /^(?:2_GLP|2_ATM|2_ZD|2_SO_GLP|2_SO_ATM|2_P_SO_GLP|2_ZTC|2_WB_COMPANY|2_GLOBAL_ATM)$/;

    var fromSellLeads = '0';
    var fromProduct = '1';
    var fromCompany = '2';
    var fromQcInspection = '100';
    var link_prefix = '//message.alibaba.com/msgsend/contact.htm?action=contact_action&';

    var Utils = {
        getFeedBackUrl: function (from, id, type) {
            var feedBackUrl = '';
            if (fromProductRegExp.test(from)) {
                from = fromProduct;
            }
            if (fromMinisiteRegExp.test(from)) {
                from = fromCompany;
            }
            if (fromSellLeads === from) {
                feedBackUrl = link_prefix + 'req_page=feedback.init&domain=0&tracelog=tmofflinefeedback0610&id=' + id;
            } else if (fromQcInspection === from) {
                feedBackUrl = link_prefix + 'chkContactIds=' + id;
            } else {
                if (type === 1) {
                    feedBackUrl = link_prefix + 'req_page=feedback.init&domain=' + from + '&tracelog=tmofflinefeedback0610&id=' + id + '&isWholesale=1';
                } else {
                    feedBackUrl = link_prefix + 'req_page=feedback.init&domain=' + from + '&tracelog=tmofflinefeedback0610&id=' + id;
                }
            }
            return feedBackUrl;
        },
        getFeedBackUrlLastest: function (from, id, encryptId, type) {
            var feedBackUrl = '';
            if (fromProductRegExp.test(from)) {
                from = fromProduct;
            }
            if (fromMinisiteRegExp.test(from)) {
                from = fromCompany;
            }
            if (fromSellLeads === from) {
                feedBackUrl = link_prefix + 'req_page=feedback.init&domain=0&tracelog=tmofflinefeedback0610&id=' + id + '&id_f=' + encryptId;
            } else if (fromQcInspection === from) {
                feedBackUrl = link_prefix + 'chkContactIds=' + id + '&chkContactIds_f=' + encryptId;
            } else {
                if (type === 1) {
                    feedBackUrl = link_prefix + 'req_page=feedback.init&domain=' + from + '&tracelog=tmofflinefeedback0610&id=' + id + '&isWholesale=1&id_f=' + encryptId;
                } else {
                    feedBackUrl = link_prefix + 'req_page=feedback.init&domain=' + from + '&tracelog=tmofflinefeedback0610&id=' + id + '&id_f=' + encryptId;
                }
            }
            return feedBackUrl;
        }
    };

    module.exports = Utils;
